define('pwa/plugin/tickets/model/TicketsModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Tickets info model
     *
     * @class TicketsModel
     */
    return BaseModel.extend({

    });

});
